module.exports = "././img/client_logo.svg";


//////////////////
// WEBPACK FOOTER
// ../assets/qld/img/client_logo.svg
// module id = 825
// module chunks = 0